import React from 'react';
import { Field } from 'redux-form';
import { Checkbox, SelectField, AutoComplete } from 'redux-form-material-ui';
import MenuItem from 'material-ui/MenuItem';
import { AutoComplete as MUIAutoComplete } from 'material-ui';

import { Filters } from '../../components/shared';

export default class JobRequestsFilter extends React.Component {
  render() {
    const {
      handleFilter,
      handleResetFilter,
      filterValues,
      allStudents,
    } = this.props;

    const fieldMap = {
      student: 'Student',
      status: 'Status',
      requestType: 'Request Type',
      hasOpenJobOffers: 'Has Open Job Offers',
    };

    const studentDataSource = allStudents.edges.map(edge => {
      const { node } = edge;
      return {
        text: `${node.firstname} ${node.lastname} (${node.user.email})`,
        value: node.id,
      };
    });

    return (
      <Filters
        handleFilter={handleFilter}
        handleResetFilter={handleResetFilter}
        fieldMap={fieldMap}
        values={filterValues}
      >
        <Field
          name="student"
          fullWidth
          floatingLabelText="Student"
          component={AutoComplete}
          openOnFocus
          filter={MUIAutoComplete.fuzzyFilter}
          dataSource={studentDataSource}
          dataSourceConfig={{ text: 'text', value: 'value' }}
        />
        <br />
        <Field name="status" floatingLabelText="Status" component={SelectField}>
          <MenuItem value="" primaryText="" />
          <MenuItem value="Open" primaryText="Open" />
          <MenuItem value="Accepted" primaryText="Accepted" />
          <MenuItem value="Cancelled" primaryText="Cancelled" />
          <MenuItem value="Completed" primaryText="Completed" />
          <MenuItem value="Expired" primaryText="Expired" />
        </Field>
        <br />
        <Field
          name="requestType"
          floatingLabelText="Request Type"
          component={SelectField}
        >
          <MenuItem value="" primaryText="" />
          <MenuItem value="Direct" primaryText="Direct" />
          <MenuItem value="Common" primaryText="Common" />
        </Field>
        <br />
        <Field
          name="hasOpenJobOffers"
          label="Has Open Job Offers"
          component={Checkbox}
        />
      </Filters>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/job/JobRequestsFilter.js